<template>
  <custom-dialog appendToBody width="700px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('d_item1_shang_ji_bu_men')">
              <el-input v-model="form.parentName" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('d_item1_bmmc')" prop="departmentName">
              <el-input v-model="form.departmentName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('d_item1_bmjc')" prop="departmentShort">
              <el-input v-model="form.departmentShort" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('d_item1_bmfzr')" prop="contactName">
              <el-input v-model="form.contactName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('d_item1_lian_xi_dian_hua')" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('d_item1_bu_men_miao_shu')" prop="departmentDesc">
              <el-input v-model="form.departmentDesc" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="saveOrgan">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>
<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

// d_item1_shang_ji_bu_men: 上级部门// d_item1_bmmc: 部门名称// d_item1_bmjc: 部门简称// d_item1_bmfzr: 部门负责人// d_item1_lian_xi_dian_hua: 联系电话// d_item1_bu_men_miao_shu: 部门描述// d_item1_bmmcbnwk: 部门名称不能为空// d_item1_cdzcgzf: 长度最长40个字符// d_item1_bmjcbnwk: 部门简称不能为空// d_item1_cdzcgzf_1: 长度最长20个字符// d_item1_cdzcgzf_2: 长度最长200个字符

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        parentId: '',
        parentName: '',
        departmentId: '',
        departmentName: '',
        departmentPath: '',
        departmentShort: '',
        departmentDesc: '',
        contactName: '',
        contactPhone: '',
        showOrder: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        departmentName: [
          {
            type: 'string',
            required: true,
            message: this.$t('d_item1_bmmcbnwk'),
          },
          {
            type: 'string',
            max: 40,
            message: this.$t('d_item1_cdzcgzf'),
          },
        ],
        departmentShort: [
          {
            type: 'string',
            required: true,
            message: this.$t('d_item1_bmjcbnwk'),
          },
          {
            max: 20,
            type: 'string',
            message: this.$t('d_item1_cdzcgzf_1'),
          },
        ],
        departmentDesc: {
          max: 200,
          type: 'string',
          message: this.$t('d_item1_cdzcgzf_2'),
        },
      };
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_department_item_dialog');
    this.initDialog();
  },
  methods: {
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.parentId = this.model.bizId;
        this.form.parentName = this.model.bizName;
      }
      if (this.model.type === 'edit') {
        this.getParentOrgan();
      }
    },
    // 获取部门信息
    getParentOrgan: function () {
      this.$getJSON(`${apis.Department}/${this.model.bizId}`).then((res) => {
        const parentData = res.data;
        this.$setFormatData(this.form, parentData);
      });
    },
    // 确认保存用户
    saveOrgan: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddOrgan();
        }
        if (this.model.type === 'edit') {
          this.saveEditOrgan();
        }
      });
    },
    // 保存新增用户
    saveAddOrgan: function () {
      this.$postJSON(apis.DepartmentAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    // 保存编辑用户
    saveEditOrgan: function () {
      this.$postJSON(apis.DepartmentUpdate, this.form, true).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
